import React, { useState } from "react"

import Logo from "../Logo"
import Button from "../Button"
import MenuMobile from "../MenuMobile"
import MenuBurger from "../MenuBurger"

import * as S from "./styled"

const Navbar = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <MenuMobile open={open} setOpen={setOpen} />

      <S.NavbarWrapper>
        <MenuBurger open={open} setOpen={setOpen} />

        <S.NavbarGroup role="navigation">
          <S.NavbarItem>
            <S.NavbarLink as="a" href="https://www.gendo.com.br/funcoes.html">
              Funções
            </S.NavbarLink>
          </S.NavbarItem>
          <S.NavbarItem>
            <S.NavbarLink as="a" href="https://www.gendo.com.br/planos.html">
              Planos
            </S.NavbarLink>
          </S.NavbarItem>
          <S.NavbarItem>
            <S.NavbarLink as="a" href="https://ajuda.gendo.com.br/">
              Ajuda
            </S.NavbarLink>
          </S.NavbarItem>

          <S.NavbarItemCentered>
            <S.NavbarLink to="/">
              <Logo />
            </S.NavbarLink>
          </S.NavbarItemCentered>

          <S.NavbarItem>
            <S.NavbarLink
              as="a"
              href="https://api.whatsapp.com/send?phone=551140033142&text=Ol%C3%A1,%20gostaria%20de%20conversar%20com%20um%20representante%20de%20vendas"
            >
              <S.NavbarIconWhatsapp />
              4003-3142
            </S.NavbarLink>
          </S.NavbarItem>
          <S.NavbarItem>
            <S.NavbarLink as="a" href="https://acesso.gendo.app/">
              <Button
                background={props => props.theme.colors.highlight}
                color={props => props.theme.colors.primary}
                padding="0.75em 1em"
              >
                <S.NavbarIconLogin />
                Sou Cliente
              </Button>
            </S.NavbarLink>
          </S.NavbarItem>
        </S.NavbarGroup>
      </S.NavbarWrapper>
    </>
  )
}
export default Navbar
